// extracted by mini-css-extract-plugin
export default {"iconInfo":"styles_iconInfo__2M0ym","item":"styles_item__xWczy","title":"styles_title__i-qV8","text":"styles_text__tQ2WQ"};